'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const WheelCanvasStyle = styled__default["default"].canvas`
  width: 98%;
  height: 98%;
`;

exports.WheelCanvasStyle = WheelCanvasStyle;
